// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-wrap .content-wrapper[data-v-9fa6a736]{width:100%;margin:0 auto;padding:0}", ""]);
// Exports
module.exports = exports;
